import requests from "./httpService";


const VehicleAllotServices = {
  getVehicleAllotList: async (body) => {
    return requests.post(`/vehicleAllotment/list`, body);
  },

  getVehicleDriverList: async (body) => {
    return requests.post(`/vehicleAllotment/allot-list`, body);
  },
  allotVehicleDriver: async (body) => {
    return requests.post(`/vehicleAllotment/allot`, body);
  },
  allotlist: async (body) => {
    return requests.post(`/vehicleAllotment/allot-list`, body);
  },
  updateTripcompletedStatus: async (id, trip) => {
    return requests.put(`/vehicleAllotment/status/${id}`);
  },
  updateVehicleTripStatus:async(id)=>{
    return requests.put(`/vehicleAllotment/status/${id}`)
  }
};

export default VehicleAllotServices;
